import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoSVG } from './logo.svg';

const Logo = () => (
  <Link to="/" className="inline-block">
    <LogoSVG className="w-40 h-auto" />
  </Link>
);

export default Logo;